import { memo } from "react";
import PublicLinkPageSurface from "../Dashboard/PublicLinkPageSurface";
import BookMeTrigger from "../Booking/BookMeTrigger";
import { demoCreator, getDemoLinkVersion } from "./homeCreatorContent";

function CreatorLinkPreview({ preset }) {
  return <PublicLinkPageSurface profileInfo={demoCreator} version={getDemoLinkVersion(preset.theme)}
    theme="_dark" preview
    bookingPreview={<BookMeTrigger className="linkPageRenderer__card linkPageRenderer__card--solid linkPageRenderer__card--comfortable"
      tabIndex={-1} onClick={event => event.preventDefault()} />} />;
}

export default memo(CreatorLinkPreview);
